import type { TenantSettings, UserSettings } from '@/stores/auth'
import { isDemoDeployment } from '@/utils/deployment'
import { apiCall } from './axiosInstance'
import { settingsApi as demoSettingsApi } from './demo/settingsApi'

const v3SettingsApi = {
	getUserSettings: async (): Promise<UserSettings> => {
		return apiCall<UserSettings>('/v3/me/settings', {
			method: 'GET',
		})
	},
	updateUserSettings: async (settingBody: {
		settings: UserSettings
	}): Promise<UserSettings> =>
		apiCall('/v3/me/settings', {
			method: 'PUT',
			data: settingBody,
		}),
	updateTenantSettings: async (settingBody: { settings: TenantSettings }): Promise<TenantSettings> =>
		apiCall('/v3/tenant-settings', {
			method: 'PATCH',
			data: settingBody.settings,
		}),
}

export const settingsApi = isDemoDeployment() ? demoSettingsApi : v3SettingsApi
